import { render } from "./NavigationFooter.vue.ts?vue&type=template&id=8d233bc8&scoped=true&ts=true!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NavigationFooter.vue?vue&type=template&id=8d233bc8&scoped=true&ts=true"
import script from "./NavigationFooter.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NavigationFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationFooter.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NavigationFooter.vue?vue&type=script&setup=true&lang=ts"

import "./NavigationFooter.vue.css?vue&type=style&index=0&id=8d233bc8&scoped=true&lang=css!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NavigationFooter.vue?vue&type=style&index=0&id=8d233bc8&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d233bc8"],['__file',"src/apps/merchant3/components/offers/v2/preparing/NavigationFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d233bc8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d233bc8', __exports__)) {
    api.reload('8d233bc8', __exports__)
  }
  
  module.hot.accept("./NavigationFooter.vue.ts?vue&type=template&id=8d233bc8&scoped=true&ts=true!=!../../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./NavigationFooter.vue?vue&type=template&id=8d233bc8&scoped=true&ts=true", () => {
    api.rerender('8d233bc8', render)
  })

}


export default __exports__